// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"158":"af162cb0","581":"2c983497","860":"2e2dcb56"}[chunkId] + ".chunk.js";
};